import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import StatusProgressbar from './StatusProgressbar';
import fetchData from '../../utils/fetchData';
import { API_BASE_URL } from '../../config/config';
function ApplicationDetails () {
  const selectedApplicationData = useSelector(
    state => state.intakeData.selectedApplicationData
  );

  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    fetchData(
      `${API_BASE_URL}/insureai/ml/intake/applications/v2/application_status?application_id=${selectedApplicationData?.application_id}`,
      'GET'
    ).then(data => {
      setStatusList(data);
    });
  }, [selectedApplicationData]);

  const coverageLine = Object.entries(
    selectedApplicationData?.coverageline_bundle || {}
  )
    .filter(([key, value]) => value === true || value === 'true')
    .map(([key]) => key)
    .join(', ');
  return (
    <div className='application-details-view'>
      <h1 className='mb-2 text-2xl text-orange-600'>Application Summary</h1>
      <div className='items-center h-full p-6 mx-auto w-full details-view shadow-md rounded-lg'>
        {/* Application Summary Section (Left Column) */}
        <div>
          <p>
            <strong>Application Id:</strong>{' '}
            {selectedApplicationData?.application_id || ''}
          </p>
          <p>
            <strong>Priority:</strong> {selectedApplicationData?.priority}
          </p>
          <p>
            <strong>LOBs:</strong> {selectedApplicationData?.lob || ''}
          </p>
          {/* <p>
            <strong>Coverage Line:</strong> {coverageLine || ''}
          </p> */}
          <p>
            <strong>Classification:</strong>{' '}
            {selectedApplicationData?.application_classification || ''}
          </p>
          <p className='flex'>
            <strong>Details:</strong>{' '}
            <div style={{ height: '100px', overflow: 'auto' }}>
              {' '}
              {selectedApplicationData?.application_detailed_summary || ''}
            </div>
          </p>
          <StatusProgressbar statusList={statusList} className='mt-6' />
        </div>
      </div>
    </div>
  );
}

export default ApplicationDetails;
